module.exports = {"140932100":"新关镇","140932101":"天峰坪镇","140932102":"老营镇","140932103":"万家寨镇","140932200":"窑头乡","140932201":"楼沟乡","140932202":"尚峪乡","140932203":"南堡子乡","140932204":"水泉乡","140932205":"陈家营乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140932.json
// module id = 358
// module chunks = 0